// src/components/FocusAreas.jsx
import React from 'react';
import './FocusAreas.css';

const FocusAreas = () => {
  const focusAreas = [
    {
      icon: '💰',
      title: 'Investment Mobilisation',
      description: 'Connecting global investors with African opportunities'
    },
    {
      icon: '🏗️',
      title: 'Bankable Project Pipeline',
      description: 'Developing investment-ready infrastructure projects'
    },
    {
      icon: '🌿',
      title: 'Climate Finance Execution',
      description: 'Implementing sustainable climate finance solutions'
    },
    {
      icon: '🏛️',
      title: 'Infrastructure Development',
      description: 'Building resilient infrastructure across Africa'
    },
    {
      icon: '🤝',
      title: 'Regional Economic Integration',
      description: 'Strengthening trade partnerships across the continent'
    },
    {
      icon: '💡',
      title: 'Innovation & Technology',
      description: 'Leveraging technology for sustainable development'
    }
  ];

  return (
    <section className="focus-section">
      <div className="focus-container">
        <div className="focus-header">
          <span className="focus-badge">OUR FOCUS</span>
          <h2 className="focus-title">Strategic Focus Areas</h2>
          <div className="focus-title-line"></div>
        </div>

        <div className="focus-grid">
          {focusAreas.map((area, index) => (
            <div className="focus-card" key={index}>
              <div className="focus-card-icon">{area.icon}</div>
              <h3 className="focus-card-title">{area.title}</h3>
              <p className="focus-card-description">{area.description}</p>
              <div className="focus-card-hover"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FocusAreas;